<template>
  <div>
    <template v-if="value.length > 0"></template>
    <div v-if="v.start_date && v.end_date">
      {{ v.start_date.format("DD.MM.YYYY") }} - {{ v.end_date.format("DD.MM.YYYY") }}
    </div>
    <div>
      Contract:
      <currency :value="v.contract_budget / 100" />
    </div>
    <div>
      Actuals (+additional):
      <currency :value="v.actuals / 100 + v.additional_actuals / 100" />
    </div>
    <div>
      Profit
      <ColoredNumber
        :value="Math.round((v.contract_budget / 100 - (v.additional_actuals / 100 + v.actuals / 100)) / (v.contract_budget / 100) * 1000) / 10"
        legend="%" />
    </div>

  </div>
</template>

<script>
import Currency from '@/views/Shared/Currency.vue';
import ColoredNumber from '@/views/Shared/ColoredNumber.vue';

export default {
  mounted() {
  },
  props: {
    value: { type: Array }
  },
  data() {
    return {
    };
  },
  components: {
    Currency,
    ColoredNumber,
  },
  computed: {
    v() { return this.value.length > 0 ? this.value[0] : {} },
  },
  watch: {
  },
  methods: {
  }
};
</script>

<style scoped lang="scss"></style>
